import React from 'react';

interface HorizontalFilterBarProps {
  filterItems: string[];
  selectedFilter: string;
  onFilterChange: (filter: string) => void;
  containerClassName?: string;
  activeClassName?: string;
  inactiveClassName?: string;
  buttonBaseClassName?: string;
  buttonHeight?: string;
  buttonPadding?: string;
  buttonBorderRadius?: string;
  buttonFontSize?: string;
}

const HorizontalFilterBar: React.FC<HorizontalFilterBarProps> = ({
  filterItems,
  selectedFilter,
  onFilterChange,
  containerClassName = "mt-5 overflow-x-auto hide-scrollbar",
  activeClassName = "bg-white/20 text-white",
  inactiveClassName = "bg-white/10 text-white",
  buttonBaseClassName = "flex items-center cursor-pointer text-center",
  buttonHeight = "h-[35px]",
  buttonPadding = "px-[20px]",
  buttonBorderRadius = "rounded-[26px]",
  buttonFontSize = "text-[10px]"
}) => {
  // Define styles to hide scrollbar across browsers
  const scrollbarHideStyles: React.CSSProperties = {
    msOverflowStyle: 'none',  
    scrollbarWidth: 'none',  
  };

  return (
    <div className={containerClassName} style={scrollbarHideStyles}>
      <div className="flex space-x-3 py-2 min-w-max">
        {filterItems.map((item) => (
          <div
            key={item}
            className={`${buttonBaseClassName} ${buttonHeight} ${buttonPadding} ${buttonBorderRadius} ${buttonFontSize} ${
              selectedFilter === item
                ? activeClassName
                : inactiveClassName
            }`}
            onClick={() => onFilterChange(item)}
          >
            <span className="whitespace-nowrap">{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HorizontalFilterBar;
